import { gql } from 'apollo-boost';

export const all = gql`
  query orgUser($orgId: ID!) {
    orgUser {
      all(orgId: $orgId) {
        id
        active
        firstName
        lastName
        email
        roleId
        phone
      }
    }
  }
`;

export const allOrgsQueryCache = gql`
  {
    organization {
      all @client {
        externalId
        orgId
        id
        name
        timeZoneId
        rowVersion
      }
    }
  }
`;

export const branding = gql`
  query branding {
    branding {
      all {
        id
        name
      }
    }
  }
`;

export const organizationTypesRefData = gql`
  query organizationTypes {
    referenceData {
      organizationTypes {
        enumValue
        name
      }
    }
  }
`;

export const paginatedOrganizations = gql`
  query paginatedOrganizations($limit: Int, $offset: Int, $searchText: String) {
    organization {
      paged(limit: $limit, offset: $offset, searchText: $searchText) {
        hasMoreData
        limit
        offset
        totalCount
        results {
          orgId
          id
          externalId
          name
          timeZoneId
          rowVersion
          config {
            organizationTypeId
            orgUsersMustAcceptEula
            rateProviders
            defaultUnitType
            defaultDensityUnit
            defaultVolumeUnit
            defaultDimensionUnit
            defaultDistanceUnit
            defaultWeightUnit
            defaultCurrency
            defaultCountry
            defaultDockOpenTime
            defaultDockCloseTime
            defaultLocationId
            defaultBillingTerms {
              addressInfo {
                address1
                address2
                city
                country
                postalCode
                state
              }
              companyName
              contactInfo {
                email
                firstName
                lastName
                phone
              }
              defaultPaymentTerms
            }
            autoGeneratedBolNumbers
            autoTenderEnabled
            p44AccountGroup
            leadTimeWindowsMinutes
            smcCCCredentials {
              license
              username
              password
            }
            smcRWCredentials {
              license
              username
              password
            }
            minimumPalletCountForVltl
            minimumWeightInPoundsForVltl
            minimumLinearFeetForVltl
            visibleLaneTypeIds
            defaultBolInstructions
            brandingId
            varianceAllowedPercent
            varianceAllowedAmount
            acceptVarianceInYourFavor
            requireSignedBolDocument
            requireProofOfDeliveryDocument
            requireGlCodeAssigned
            automaticallyAcceptInvoiceWithinVarianceThreshold
          }
        }
      }
    }
  }
`;

export const orgInfo = gql`
  query organization($id: ID!) {
    organization {
      byId(id: $id) {
        id
        mainBusiness {
          id
          rootDivision {
            id
          }
        }
        config {
          defaultCountry
          defaultCurrency
          defaultDensityUnit
          defaultDimensionUnit
          defaultVolumeUnit
          defaultWeightUnit
          organizationTypeId
          p44AccountGroup
          defaultBolInstructions
          defaultDockOpenTime
          defaultDockCloseTime
          orgUsersMustAcceptEula
        }
      }
    }
  }
`;

export const byId = gql`
  query organization($id: ID!) {
    organization {
      byId(id: $id) {
        orgId
        id
        externalId
        name
        timeZoneId
        rowVersion
        config {
          organizationTypeId
          orgUsersMustAcceptEula
          rateProviders
          defaultUnitType
          defaultDensityUnit
          defaultVolumeUnit
          defaultDimensionUnit
          defaultDistanceUnit
          defaultWeightUnit
          defaultCurrency
          defaultCountry
          defaultDockOpenTime
          defaultDockCloseTime
          defaultLocationId
          defaultBillingTerms {
            addressInfo {
              address1
              address2
              city
              country
              postalCode
              state
            }
            companyName
            contactInfo {
              email
              firstName
              lastName
              phone
            }
            defaultPaymentTerms
          }
          autoGeneratedBolNumbers
          autoTenderEnabled
          p44AccountGroup
          leadTimeWindowsMinutes
          smcCCCredentials {
            license
            username
            password
          }
          smcRWCredentials {
            license
            username
            password
          }
          minimumPalletCountForVltl
          defaultBolInstructions
          minimumWeightInPoundsForVltl
          minimumLinearFeetForVltl
          visibleLaneTypeIds
          brandingId
          varianceAllowedPercent
          varianceAllowedAmount
          acceptVarianceInYourFavor
          requireSignedBolDocument
          requireProofOfDeliveryDocument
          requireGlCodeAssigned
          automaticallyAcceptInvoiceWithinVarianceThreshold
        }
      }
    }
  }
`;
